<template>
  <v-app id="inspire">
    <v-app-bar flat app class="custom-app-bar">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Welcome {{ receivedUser.username }}!</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-avatar size="36">
        <img :src="receivedUser.photo" :alt="receivedUser.username" />
      </v-avatar>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab depressed small dark color="#fff" v-bind="attrs" v-on="on">
            <v-icon color="grey">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/dashboard/settings">
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app>
      <v-list-item>
        <v-list-item-content>
          <v-img
            class="mb-5 mt-4 ml-2"
            max-width="160"
            src="@/assets/flybysms.svg"
          ></v-img>
        </v-list-item-content>
      </v-list-item>

      <v-list dense>
        <v-list-item v-for="item in items" :key="item.title" :to="item.to" link>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <v-list flat>
          <v-list-item-group>
            <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon>mdi-logout-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Log Out</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-main class="mx-2 mb-4">
      <!-- <ProgressCircular v-if="$store.state.progressbar.show" /> -->
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
// import ProgressCircular from "@/components/shared/ProgressCircular.vue";
export default {
  components: {
    // ProgressCircular,
  },
  data: () => ({
    drawer: null,
    items: [
      {
        title: "Overview",
        icon: "mdi-view-dashboard",
        to: "/dashboard/stats",
      },
      {
        title: "Send SMS",
        icon: "mdi-send",
        to: "/dashboard/send-sms",
      },
      {
        title: "Sent",
        icon: "mdi-message-check",
        to: "/dashboard/sent-sms",
      },
      {
        title: "SMS Templates",
        icon: "mdi-notebook",
        to: "/dashboard/sms-template",
      },
      {
        title: "Contacts",
        icon: "mdi-contacts",
        to: "/dashboard/contacts",
      },
      {
        title: "Contact Groups",
        icon: "mdi-account-group-outline",
        to: "/dashboard/groups",
      },
      {
        title: "Request SenderId",
        icon: "mdi-sim",
        to: "/dashboard/senderid",
      },
      {
        title: "Wallet",
        icon: "mdi-wallet",
        to: "/dashboard/wallet",
      },
      {
        title: "Transactions",
        icon: "mdi-receipt-text",
        to: "/dashboard/transactions",
      },
      {
        title: "Balance Swap",
        icon: "mdi-transfer",
        to: "/dashboard/balance-swap",
      },
      {
        title: "My Referral",
        icon: "mdi-handshake",
        to: "/dashboard/referrals",
      },
      {
        title: "Settings",
        icon: "mdi-cog-outline",
        to: "/dashboard/settings",
      },
    ],
  }),
  computed: {
    receivedUser() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.custom-app-bar {
  border-bottom: 1px solid #ccc !important;
  background-color: white !important;
}
</style>
